module.exports = __webpack_public_path__ + "img/logo-tnl.1ff69bd8.png";